import React, { useEffect, useState } from 'react';
import { Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';
import { useUser } from '../../../../userContext';

export default function AdminAppModal({ application, onTriggerCreate, onTriggerUpdate }) {

  const { userId } = useUser();

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  
  const [formData, setFormData] = useState({
      id: application.id,
      collector: application.collector,
      name: application.name,
      port: application.port,
      authorized: application.authorized ? application.authorized : false,
      notes: application.notes
  });

  const handleOpen = () => {
    setFormData({ ...formData, created_by_id: userId });
    setOpen(true);
    setTitle('Create Application');
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update Application');
  }

  const handleUpdate = async (event) => {
      await editApplication(event);      
      setOpen(false);
      if (formData.id === undefined) { 
        onTriggerCreate(formData);
      } else {
        onTriggerUpdate(formData);
      }
  }

  const handleClose = () => setOpen(false);

  const handleInputChange = (field) => (event) => {    
      const value = event.target.value;
      setFormData({ ...formData, [field]: value });
  };
  
  const editApplication = async (event) => {
    try {
        event.preventDefault();
        let response = null;
        if (formData.id === undefined) {
            response = await fetch(`${process.env.REACT_APP_API}/applications`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
        } else {
            response = await fetch(`${process.env.REACT_APP_API}/applications/${formData.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
        }
        const result = await response.json();
        return result;
    } catch (error) {
      console.error('Network error.  Please try again: ', error);
    }
  }

  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ]
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    if (application.id !== undefined) {
      setFormData(application);
    } 
  }, [application]);

  return (
    <>

        { application === "" && 
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen} >
            Add New
          </Button>
        }
        
        { application !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', // Semi-transparent black
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            label="IP"
                            value={formData.ip_dns}
                            onChange={handleInputChange('ip_dns')}
                            sx={ textFieldStyles }
                        />
                        <TextField
                            fullWidth
                            label="Collector"
                            value={formData.collector}
                            onChange={handleInputChange('collector')}
                            sx={ textFieldStyles }
                        />
                        <TextField
                            fullWidth
                            label="App Name"
                            value={formData.name}
                            onChange={handleInputChange('name')}
                            sx={ textFieldStyles }
                        />
                        <TextField
                            fullWidth
                            label="Port"
                            type="number"
                            value={formData.port}
                            onChange={handleInputChange('port')}
                            sx={ textFieldStyles }
                        />
                        <TextField
                          select 
                          required
                          fullWidth
                          label="Authorized"
                          value={formData.authorized}
                          onChange={handleInputChange('authorized')}
                          sx={ textFieldStyles }  
                        >
                          {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </TextField>
                      <TextField
                        fullWidth
                        label="Note"
                        value={formData.notes}
                        onChange={handleInputChange('notes')}
                        sx={ textFieldStyles }
                      />
                  <ButtonGroup 
                    size="small"
                    variant="contained" 
                    aria-label="Basic button group" 
                    fullWidth
                    sx={{ mt:2 }}
                  >
                    <Button
                      onClick={handleClose}
                      type="cancel"
                      variant="contained"
                      sx={ Styles.buttonStyle }
                    >
                      Cancel
                    </Button>              
                    <Button
                      type="submit"                      
                      variant="contained"
                      sx={{ ...Styles.buttonStyle,  ml:4 }}
                    >
                      {title}
                    </Button>
                  </ButtonGroup>
                </Stack>
              </Box>
            </Box>
          </Box>          
        </Modal>
    </>
  );
}